import { Building2, Check, ChevronsUpDown, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { CompanyLogo } from "@/components/business/CompanyLogo";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { setActiveCompany, useActiveCompany } from "@/lib/activeCompany";

const ROLES = { director: "Dirigeant", accountant: "Comptable", viewer: "Lecteur" };

export const CompanySwitcher = () => {
  const { user } = useAuth();
  const active = useActiveCompany();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const pick = (id) => { setActiveCompany(id); qc.invalidateQueries(); navigate("/entreprise"); };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex min-w-0 items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-sm font-medium transition-colors hover:bg-secondary" data-testid="company-switcher-button">
        {active ? <CompanyLogo company={active} className="h-5 w-5" /> : <Building2 className="h-4 w-4" />}
        <span className="max-w-[9rem] truncate sm:max-w-[14rem]">{active?.name || "CASHMY Entreprise"}</span>
        <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel className="eyebrow">Mes entreprises</DropdownMenuLabel>
        {(user.companies || []).map((c) => (
          <DropdownMenuItem key={c.id} onClick={() => pick(c.id)} className="flex items-center gap-2" data-testid={`company-option-${c.id}`}>
            <CompanyLogo company={c} className="h-6 w-6" />
            <div className="min-w-0 flex-1"><div className="truncate">{c.name}</div><div className="text-xs text-muted-foreground">{ROLES[c.role] || c.role}</div></div>
            {active?.id === c.id && <Check className="h-4 w-4 text-sage" />}
          </DropdownMenuItem>
        ))}
        {!user.read_only && !user.is_demo && <><DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => navigate("/entreprise/nouvelle")} data-testid="company-add-link"><Plus className="mr-2 h-4 w-4" />Ajouter une entreprise</DropdownMenuItem></>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
